/*import { AttachFileOutlined } from "@material-ui/icons";
import { useEffect, useState } from "react";
import MathEditor from "../MathEditor/MathEditor";

import FormulaIcon from "../../../images/formula.png";

export default function QuestionInput({
  placeholder,
  name,
  value,
  image,
  disabled,
  handleInput,
  handleFileUpload,
  styles,
}) {
  const [openEditor, setOpenEditor] = useState(false);

  function save(content) {
    handleInput(content);
    setOpenEditor(false);
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        opacity: disabled ? "0.5" : "1",
        cursor: disabled ? "not-allowed" : "pointer",
        marginBottom:"5px"
      }}
    >
      <div style={{ flex: 1 }}>
        <div
          className="input"
          style={{
            flex: 1,
            ...styles,
          }}
        >
          <textarea
            name={name}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            onChange={(e) => handleInput(e.target.value)}
            className="textInput"
            style={{
              height: "auto !important",
            }}
          />
          {handleFileUpload && (
            <div
              className="icon"
              style={{ display: disabled ? "none" : "block" }}
            >
              <label style={{ display: "flex" }} htmlFor={name}>
                <AttachFileOutlined />
              </label>
              <input
                id={name}
                name={name}
                style={{ display: "none" }}
                type="file"
                accept="images/*"
                onChange={handleFileUpload}
              />
            </div>
          )}
        </div>
        {image || ""}
      </div>
      {openEditor && (
        <MathEditor
          closeEditor={() => setOpenEditor(false)}
          saveEditor={save}
          initialHtml={value}
        />
      )}
      <img
        src={FormulaIcon}
        style={{
          width: "20px",
          margin: "auto 10px auto 5px",
          cursor: "pointer",
        }}
        onClick={() => {
          if (disabled) return;
          setOpenEditor(true);
        }}
      />
    </div>
  );
}
*/

import { AttachFileOutlined } from "@material-ui/icons";
import { useEffect, useRef, useState } from "react";
import MathEditor from "../MathEditor/MathEditor";

import FormulaIcon from "../../../images/formula.png";

export default function QuestionInput({
  placeholder,
  name,
  value,
  image,
  disabled,
  handleInput,
  handleFileUpload,
  styles,
  editor = false,
}) {
  const [openEditor, setOpenEditor] = useState(false);

  const editorRef = useRef(null);

  useEffect(() => {
    if (
      editor &&
      editorRef.current &&
      editorRef.current.innerHTML !== value
    ) {
      editorRef.current.innerHTML = value || "";
    }
  }, [value, editor]);

  function save(content) {
    if (editor) {
      const updatedContent = `${value || ""}${content}`;

      handleInput(updatedContent);

      if (editorRef.current) {
        editorRef.current.innerHTML = updatedContent;
      }
    } else {
      handleInput(content);
    }

    setOpenEditor(false);
  }

  const handleContentEditableInput = () => {
    if (!editorRef.current) return;

    handleInput(editorRef.current.innerHTML);
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        opacity: disabled ? "0.5" : "1",
        cursor: disabled ? "not-allowed" : "default",
        marginBottom: "5px",
      }}
    >
      <div style={{ flex: 1 }}>
        <div
          className="input"
          style={{
            flex: 1,
            alignItems: "flex-start",
            ...styles,
          }}
        >
          {editor ? (
            <div
              ref={editorRef}
              contentEditable={!disabled}
              suppressContentEditableWarning={true}
              onInput={handleContentEditableInput}
              data-placeholder={placeholder}
              className="textInput contentEditableInput"
              style={{
                minHeight: "120px",
                width: "100%",
                outline: "none",
                background: "transparent",
                padding: "10px",
                overflowWrap: "break-word",
                whiteSpace: "pre-wrap",
              }}
            />
          ) : (
            <textarea
              name={name}
              value={value}
              placeholder={placeholder}
              disabled={disabled}
              onChange={(e) =>
                handleInput(e.target.value)
              }
              className="textInput"
              style={{
                height: "auto",
              }}
            />
          )}

          {handleFileUpload && (
            <div
              className="icon"
              style={{
                display: disabled ? "none" : "block",
              }}
            >
              <label
                style={{ display: "flex" }}
                htmlFor={name}
              >
                <AttachFileOutlined />
              </label>

              <input
                id={name}
                name={name}
                style={{ display: "none" }}
                type="file"
                accept={editor
                    ? "image/*,audio/*,video/*"
                    : "image/*"}
                onChange={handleFileUpload}
              />
            </div>
          )}
        </div>

        {image || ""}
      </div>

      {openEditor && (
        <MathEditor
          closeEditor={() => setOpenEditor(false)}
          saveEditor={save}
          initialHtml={value}
        />
      )}

      <img
        src={FormulaIcon}
        style={{
          width: "20px",
          margin: "auto 10px auto 5px",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        onClick={() => {
          if (disabled) return;

          setOpenEditor(true);
        }}
      />
    </div>
  );
}